import { coreKey } from 'queryKeys';

const RELEASE_VERSION_KEY = 'release-version';

export const releaseVersion = coreKey.all(RELEASE_VERSION_KEY);
